import type { HTTPFunctions, CacheParameter } from './types';

const webChecker = ({ get }: HTTPFunctions) => ({
  getAccesibilityHTML: (url: string, cache: CacheParameter) => get(`/accesibility/html?url=${url}&cache=${cache}`),
});

export default webChecker;
